var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoCalculator = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_49032",
    "data-name": "Path 49032",
    d: "M78.021,0H67.647a1.776,1.776,0,0,0-1.813,1.732V16.268A1.776,1.776,0,0,0,67.647,18H78.021a1.776,1.776,0,0,0,1.813-1.732V1.732A1.776,1.776,0,0,0,78.021,0Zm-9.7,2.992a.54.54,0,0,1,.552-.527H76.8a.54.54,0,0,1,.552.527V4.033a.54.54,0,0,1-.552.527H68.871a.54.54,0,0,1-.552-.527Zm1.859,11.841a.54.54,0,0,1-.552.527h-.755a.54.54,0,0,1-.552-.527v-.5a.54.54,0,0,1,.552-.527h.755a.54.54,0,0,1,.552.527Zm0-3.121a.54.54,0,0,1-.552.527h-.755a.54.54,0,0,1-.552-.527v-.5a.54.54,0,0,1,.552-.527h.755a.54.54,0,0,1,.552.527Zm3.631,3.121a.54.54,0,0,1-.552.527H72.5a.54.54,0,0,1-.552-.527v-.5a.54.54,0,0,1,.552-.527h.755a.54.54,0,0,1,.552.527Zm0-3.121a.54.54,0,0,1-.552.527H72.5a.54.54,0,0,1-.552-.527v-.5a.54.54,0,0,1,.552-.527h.755a.54.54,0,0,1,.552.527Zm0-3.121a.54.54,0,0,1-.552.527H68.871a.54.54,0,0,1-.552-.527v-.5a.54.54,0,0,1,.552-.527h4.385a.54.54,0,0,1,.552.527Zm3.631,6.242a.54.54,0,0,1-.552.527h-.755a.54.54,0,0,1-.552-.527v-.5a.54.54,0,0,1,.552-.527h.755a.54.54,0,0,1,.552.527Zm0-3.121a.54.54,0,0,1-.552.527h-.755a.54.54,0,0,1-.552-.527v-.5a.54.54,0,0,1,.552-.527h.755a.54.54,0,0,1,.552.527Zm0-3.121a.54.54,0,0,1-.552.527h-.755a.54.54,0,0,1-.552-.527v-.5a.54.54,0,0,1,.552-.527h.755a.54.54,0,0,1,.552.527Z",
    transform: "translate(-65.834)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoCalculator);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_calculator.b54154258ddf99e8a9b55cbb3fe90b32.svg";